import React from 'react';
import { Quote } from 'lucide-react';
import { motion } from 'framer-motion';
export function ExpertQuote() {
  return <section className="py-16 bg-cream" data-id="element-77">
      <div className="max-w-3xl mx-auto px-4" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative bg-white p-8 md:p-12 rounded-2xl shadow-lg border border-forestGreen/10" data-id="element-79">
          <Quote className="absolute top-6 left-6 w-12 h-12 text-forestGreen/20" data-id="element-80" />
          <blockquote className="relative z-10" data-id="element-81">
            <p className="font-serif text-xl md:text-2xl text-gray-800 leading-relaxed italic mb-6 text-center" data-id="element-82">
              "Übelkeit bei Hunden entsteht häufig durch eine gereizte
              Magenschleimhaut oder unausgeglichene Darmflora. Natürliche
              Inhaltsstoffe wie Mariendistel und Artischocke können hier gezielt
              und sanft unterstützen."
            </p>
            <footer className="text-center" data-id="element-83">
              <cite className="font-serif font-bold text-forestGreen not-italic text-lg" data-id="element-84">
                – Dr. Nane Schomburg, Tierärztin
              </cite>
            </footer>
          </blockquote>
        </motion.div>
      </div>
    </section>;
}